import { createSlice } from "@reduxjs/toolkit";

export const productsSlice= createSlice({
    name:"products",
    initialState:{
        productsList:[],
        totalProducts:0,
        singleProduct:{},
        initialImage:"",
        categoryList:[],
        totalCategory:0

    },
    reducers:{
        setProductsList:(state,action)=>{
            state.productsList = action.payload;
        },
        setTotalProducts:(state,action)=>{
            state.totalProducts = action.payload;
        },
        setCategoryList:(state,action)=>{
            state.categoryList = action.payload;
        },
        setTotalCategory:(state,action)=>{
            state.totalCategory = action.payload;
        },
        setSingleProduct:(state,action)=>{
            state.singleProduct = action.payload;
        },
        setInitialImage:(state,action)=>{
            state.initialImage = action.payload;
        }
    }
})

export const {setProductsList,setTotalProducts,setSingleProduct,setInitialImage,setCategoryList,setTotalCategory} = productsSlice.actions;
export default productsSlice.reducer; 